@if (showConduiteP1Widget()) {
  <div data-test="conduite-p1-widget" class="component-wrapper">
    <ion-item class="title_left" lines="full">
      <ion-icon name="flash-outline" aria-hidden="true"></ion-icon>
      <span>{{ 'HOME.CONDUITE_P1.TITLE' | translate }}</span>
    </ion-item>
    @if (isLoading()) {
      <div class="loading-content center">
        <ion-icon name="sync" class="infinite-rotate"></ion-icon>
        <span>{{ 'GLOBAL.LOADING' | translate }}</span>
      </div>
    } @else if (!isOnline()) {
      <ion-item lines="none">
        <ion-label class="offline">
          {{ 'HOME.CONDUITE_P1.OFFLINE_MESSAGE' | translate }}
        </ion-label>
      </ion-item>
    } @else {
      <ion-list class="custom-list">
        @if (hasAlerteTemperatureError()) {
          <ion-item lines="none">
            <ion-label class="offline">Une erreur est survenue, veuillez réessayer.</ion-label>
          </ion-item>
        } @else {
          <ion-item lines="full" (click)="goToAlertesTemperaturesPage()">
            <ion-icon name="thermometer-outline" slot="start"></ion-icon>
            <ion-label>{{ 'HOME.CONDUITE_P1.ALERT' | translate }}</ion-label>
            <div class="alert-right" slot="end">
              @if (hasAlertTemperature()) {
                <span data-test="widget-conduite-p1-has-alerte-temperature">{{ numberOfAlertsTemperature() }}</span>
                <ion-icon name="warning-sharp"></ion-icon>
              } @else {
                <ion-icon data-test="widget-conduite-p1-has-no-alerte-temperature" name="checkmark-circle"></ion-icon>
              }
            </div>
            <ion-icon
              [class.disabled]="!hasAlertTemperature()"
              class="chevron"
              name="chevron-forward-outline"
              slot="end"
            ></ion-icon>
          </ion-item>
        }
        <ion-item lines="none" (click)="navigateToTdbMensuel()">
          <ion-icon name="stats-chart-outline" slot="start"></ion-icon>
          <ion-label>{{ 'HOME.CONDUITE_P1.TABLEAU' | translate }}</ion-label>
          <ion-icon class="chevron" name="chevron-forward-outline" slot="end"></ion-icon>
        </ion-item>
      </ion-list>
    }
  </div>
}
